import './checkbox-group-item.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './checkbox-group-item.module.scss.js';
import { Checkbox } from '../checkbox/index.js';

/**
 * @component CheckboxGroupItem
 * @package Checboxes
 */
const CheckboxGroupItem = forwardRef((props, ref) => {
    const { surface = 'lightPrimary', onClick, selected, disabled, 'data-testid': testId = 'test-checkbox-item' } = props, rest = __rest(props, ["surface", "onClick", "selected", "disabled", 'data-testid']);
    const _handleClick = (e) => {
        /* istanbul ignore if -- @preserve */
        if (e.type === 'click' && e.detail !== 0) {
            e.currentTarget.blur();
        }
        /* istanbul ignore else -- @preserve */
        if (onClick) {
            onClick(e);
        }
    };
    return (jsx("div", { className: styles.checkboxWrapper, "data-testid": testId, onClick: _handleClick, children: jsx(Checkbox, Object.assign({ surface: surface, selected: selected, disabled: disabled, width: "100%" }, rest, { ref: ref })) }));
});

export { CheckboxGroupItem as default };
